<template>
  <b-card class="account-card">
    <h2 slot="header" class="account-card__title">
      {{ $t("account.set_phone_login_title", "Login by Phone") }}
    </h2>

    <section>
      <accountSetPhoneLogin :defaultCountry="defaultCountry" />
    </section>
  </b-card>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";

import accountSetPhoneLogin from "@/components/accountSetPhoneLogin.vue";

export default defineComponent({
  name: "SetPhoneLogin",
  components: {
    accountSetPhoneLogin,
  },
  computed: {
    ...mapState({
      defaultCountry: (s) => s.account.userCountry,
    }),
  },
});
</script>

<style></style>
